
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26.314 25.763"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Pfad 499","d":"M3.839-.001a.52.52 0 01.388.179.667.667 0 010 .867L1.874 3.679h14.573c5.441 0 9.867 4.953 9.867 11.042s-4.426 11.042-9.867 11.042H.55a.617.617 0 010-1.226h15.9c4.836 0 8.771-4.4 8.771-9.815s-3.935-9.815-8.771-9.815H1.873L4.226 7.54a.667.667 0 010 .867.51.51 0 01-.776 0L.161 4.727a.618.618 0 01-.12-.2.688.688 0 010-.469.594.594 0 01.12-.2L3.449.179a.528.528 0 01.39-.18z","fill":"#004588"}})])
          )
        }
      }
    